'use client';

import { Header, Link, Text } from '@inato/ui';
import { useCallback } from 'react';

import { ErrorPagesLayout } from '@components/AppLayout/ErrorPagesLayout';
import { usePlatformService } from '../../PlatformContext';
import { CONTACT_US_EMAIL } from '../../shared/constants/emails';

export const SomethingUnexpectedHappened = () => {
  const platformService = usePlatformService();
  const refreshPage = useCallback(() => {
    platformService.reload();
  }, [platformService]);
  return (
    <ErrorPagesLayout>
      <div className="mt-l desktop:mt-xl m-auto flex max-w-[640px] flex-col">
        <Header className="mb-xl" tag="h1" size="5xl">
          Something unexpected happened
        </Header>
        <Text className="mb-l" asSpan size="l">
          Our team has been notified.
        </Text>
        <Text asSpan size="l">
          In the meantime, here is what you can do:
        </Text>
        <ul className="m-zero pl-l text-l leading-l">
          <li>
            <Link onClick={refreshPage}>Refresh the page</Link> (sometimes this
            helps)
          </li>
          <li>Try again later</li>
          <li>
            Email us at{' '}
            <Link href={`mailto:${CONTACT_US_EMAIL}`}>{CONTACT_US_EMAIL}</Link>{' '}
            and tell us what happened
          </li>
          <li>
            <Link href="/">Go back to home</Link>
          </li>
        </ul>
      </div>
    </ErrorPagesLayout>
  );
};
